import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useLanguage } from '@/contexts/LanguageContext';

const commonCurrencies = ['EUR', 'USD', 'GBP', 'JPY', 'CHF', 'CAD'];

interface StepCurrencyProps {
  onNext: (currency: string) => void;
  onSkip: () => void;
}

export const StepCurrency = ({ onNext, onSkip }: StepCurrencyProps) => {
  const { t } = useLanguage();
  const [currency, setCurrency] = useState('EUR');
  const [customMode, setCustomMode] = useState(false);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="text-center space-y-2">
        <h2 className="text-2xl-adhd font-bold">{t('onboarding.currency.title')}</h2>
        <p className="text-muted-foreground">{t('onboarding.currency.subtitle')}</p>
      </div>

      {!customMode ? (
        <>
          <div className="grid grid-cols-3 gap-3">
            {commonCurrencies.map((cur) => (
              <Button
                key={cur}
                variant={currency === cur ? 'default' : 'outline'}
                onClick={() => setCurrency(cur)}
                className={`min-h-touch px-6 py-3 ${currency === cur ? 'shadow-lg scale-105' : ''} transition-all`}
              >
                {cur}
              </Button>
            ))}
          </div>
          <button
            onClick={() => setCustomMode(true)}
            className="w-full text-sm text-muted-foreground hover:text-foreground transition-colors py-2"
          >
            {t('onboarding.currency.other')}
          </button>
        </>
      ) : (
        <>
          <Input
            value={currency}
            onChange={(e) => setCurrency(e.target.value.toUpperCase())}
            className="text-xl-adhd min-h-touch text-center"
            maxLength={3}
            autoFocus
          />
          <button
            onClick={() => setCustomMode(false)}
            className="w-full text-sm text-muted-foreground hover:text-foreground transition-colors py-2"
          >
            {t('onboarding.currency.showCommon')}
          </button>
        </>
      )}

      <div className="space-y-2">
        <Button onClick={() => onNext(currency)} className="w-full min-h-touch">
          {t('onboarding.currency.next')}
        </Button>
        <button 
          onClick={onSkip}
          className="w-full text-sm text-muted-foreground hover:text-foreground transition-colors py-2"
        >
          {t('onboarding.currency.skip')}
        </button>
      </div>
    </div>
  );
};
